import React, { Component } from "react";
import { LargeItem } from "../components/items";
import firebase from "../config/firebaseInit";
import Lieu, { Reservation, Position, Service, UserSend } from "../model/lieux";
import geolib from "geolib";


function calcCrow(lat1, lon1, lat2, lon2) {
    let R = 6371; // km
    let dLat = toRad(lat2 - lat1);
    let dLon = toRad(lon2 - lon1);
    lat1 = toRad(lat1);
    lat2 = toRad(lat2);

    let a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
    let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    let d = R * c;
    return d;
}

function toRad(Value) {
    return Value * Math.PI / 180;
}

let db = firebase.firestore();



class Proche extends Component {
    constructor(props) {
        super(props);
        this.state = { proche: [] }
    }
    componentDidMount() {
        let lat = null;
        let long = null;
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                lat = position.coords.latitude;
                long = position.coords.longitude;
            }, function () { });
        }

        db.collection('lieux').get()
            .then((snapshot) => {
                let customArray = [];
                snapshot.forEach((doc) => {

                    let lieu = new Lieu(doc.data().pathToImage, doc.data().designation, calcCrow(lat, long, doc.data().position.latitude, doc.data().position.longitude).toFixed(1), doc.data().adresse, doc.data().description
                        , doc.data().heureFermeture, doc.data().heureOuverture, new Position(doc.data().position.latitude, doc.data().position.longitude)
                        , new Reservation(doc.data().numero, doc.data().state), new Service([], []),
                        doc.data().type, doc.data().telephone, "", "", "", doc.data().ville, doc.data().selectedArrondisement
                        ,
                        new UserSend(doc.data().sendBy.pathToImage, doc.data().sendBy.name)
                        , doc.data().categorie, doc.data().anonymous);
                    customArray.push(lieu);
                });

                customArray.sort((a, b) => {
                    if (lat != null && long != null) {

                        let position1 = geolib.getDistance(
                            { latitude: lat, longitude: long },
                            { latitude: a.position.latitude, longitude: a.position.longitude })

                        let position2 =
                            geolib.getDistance(
                                { latitude: lat, longitude: long },
                                { latitude: b.position.latitude, longitude: b.position.longitude })
                        return position1 - position2;
                    }
                });

                this.setState({ proche: customArray });
            })
            .catch((err) => {
                console.log('Error getting documents', err);
            });
    }

    render() {

        return (
            <div className="album py-5">
                <div className="container">
                    <div className="row">
                        <div className="col-12 mb-3">
                            <h4>Les coins les plus proche</h4>
                        </div>
                        {
                            this.state.proche.map((current) => <LargeItem image={""} lieu={current} />)
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default Proche;